import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../src/assets/styles/ListPets.css"
import Header from "./Components/Header/Header";
import EditMessageModal from "./EditMessageModal"
import EditImageModal from './EditImageModal';


const ListPets = () => {
    const [pets, setPets] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [editablePetId, setEditablePetId] = useState(null); // To track which pet is being edited
    const [editedField, setEditedField] = useState(""); // To track the field being edited
    const [editedValue, setEditedValue] = useState(""); // The new value for the field
    const [showModal, setShowModal] = useState(false); // State to control the modal visibility
    const [currentMessage, setCurrentMessage] = useState("");
    const [currentCharacter, setCurrentCharacter] = useState(""); // For storing the pet character message
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [selectedPetId, setSelectedPetId] = useState(null);

    const navigate = useNavigate();

    const filteredPets = pets.filter(
        (pet) =>
            pet.petName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            pet.ownerName.toLowerCase().includes(searchTerm.toLowerCase())
    );

    useEffect(() => {
        const fetchPets = async () => {
            const credentials = JSON.parse(localStorage.getItem("credentials"));
            const userEmail = credentials?.email || "";
            if (!userEmail) {
                return;
            }

            try {
                const response = await axios.get("https://us-central1-pet-finder-450419.cloudfunctions.net/list-pets", {
                    params: { email: userEmail }
                });
                console.log(response.data)
                if (response.data.length === 0) {
                    setErrorMessage("No hay mascotas para mostrar.");
                } else {
                    setPets(response.data);
                }
            } catch (error) {
                console.error("Error fetching pets:", error);
                setErrorMessage("No hay mascotas para mostrar.");
            }
        };
        fetchPets();
    }, []);


    const handleEditClick = (petId, field, value) => {
        console.log("Editing:", field, "for petId:", petId, "with value:", value); // Debugging

        setEditablePetId(petId); // Set the pet ID being edited
        setEditedField(field); // Set the field being edited (e.g., "location")
        setEditedValue(value); // Set the current value for the field (e.g., the current location)
        setShowModal(true); // Open the modal for editing
    };

    // const handleSave = async (petId) => {
    //     try {
    //         const response = await axios.put("https://updatepet-867228903962.us-central1.run.app", {
    //             petId,
    //             field: editedField,
    //             value: editedValue,
    //         });
    //         console.log(response.data);
    //         setEditablePetId(null); // Hide edit mode after saving
    //         setPets(pets.map((pet) => (pet.petId === petId ? { ...pet, [editedField]: editedValue } : pet))); // Update local state
    //     } catch (error) {
    //         console.error("Error updating pet:", error);
    //         setErrorMessage("Failed to update pet");
    //     }
    // };
    const handleSave = async (petId, field, newValue) => {
        try {
            console.log("Saving pet:", petId, field, newValue);

            const response = await axios.put("https://updatepet-867228903962.us-central1.run.app", {
                petId,
                field,
                value: newValue,
            });

            console.log(response.data);

            // Update the pet list with the new value for any field
            setPets(pets.map((pet) =>
                pet.petId === petId ? { ...pet, [field]: newValue } : pet
            ));

            setEditablePetId(null); // Hide edit mode after saving (for inline editing)
        } catch (error) {
            console.error("Error updating pet:", error);
            setErrorMessage("Failed to update pet");
        }
    };

    // const openModal = (petId, field, currentValue) => {
    //     setEditablePetId(petId);
    //     if (field === "customMessage") {
    //         setCurrentMessage(currentValue);
    //     } else if (field === "petCharacter") {
    //         setCurrentCharacter(currentValue);
    //     }
    //     setShowModal(true);
    // };

    const openModal = (petId, field, currentMessage) => {
        setEditablePetId(petId);
        setEditedField(field);
        setEditedValue(currentMessage);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setEditablePetId(null);
        setCurrentMessage("");
        setCurrentCharacter("");
    };

    const handleImageUpload = async (petId, file) => {
        try {
            // Step 1: Get Signed URL from Cloud Function
            const response = await axios.post(
                "https://us-central1-moonlit-sphinx-400613.cloudfunctions.net/add-cover-photo-album",
                {
                    filename: file.name,
                    contentType: file.type,
                }
            );

            if (response.status !== 200) {
                throw new Error("Failed to get signed URL");
            }

            const { uploadUrl, publicUrl } = response.data;

            // Step 2: Upload Image to Cloud Storage
            const uploadResponse = await axios.put(uploadUrl, file, {
                headers: { "Content-Type": file.type },
            });

            if (uploadResponse.status === 200) {
                console.log("Image uploaded successfully!");
                // Step 3: Call handleSave to update Firestore and state
                await handleSave(petId, "uploadedImageUrl", publicUrl);
                setShowUploadModal(false); // Close the modal after upload is complete
            } else {
                throw new Error("Image upload failed");
            }
        } catch (error) {
            console.error("Error uploading image:", error);
        }
    };

    return (
        <div className="list-pets-container">
        <Header />
        {errorMessage && <p className="error-message">{errorMessage}</p>}
    
        <div className="pets-container">
            <h2>Lista de mascotas registradas</h2>
    
            <div className="search-container">
                <input
                    type="text"
                    placeholder="Buscar por nombre o dueño..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                />
            </div>
    
            {filteredPets.map((pet) => (
                <div key={pet.petId} className="pet-card-list-pets">
                    <div className="pet-header">
                        <img 
                            src={pet.uploadedImageUrl || "default-image.jpg"} 
                            alt={pet.petName} 
                            className="pet-image"
                            onClick={() => {
                                setSelectedPetId(pet.petId);
                                setShowUploadModal(true);
                            }} 
                            style={{ cursor: "pointer" }}
                        />
                        <h3>
                            {editablePetId === pet.petId && editedField === "petName" ? (
                                <EditMessageModal
                                    show={showModal}
                                    onClose={() => setShowModal(false)}
                                    petId={pet.petId}
                                    field="petName"
                                    currentValue={pet.petName}
                                    handleSave={handleSave}
                                />
                            ) : (
                                <>
                                    {pet.petName}
                                    <i
                                        className="fas fa-pencil-alt"
                                        onClick={() => handleEditClick(pet.petId, "petName", pet.petName)}
                                        style={{ cursor: "pointer", marginLeft: "10px" }}
                                    ></i>
                                </>
                            )}
                        </h3>
                    </div>
    
                    <div className="pet-details">
                        {[
                            { label: "Tipo", field: "petType", value: pet.petType },
                            { label: "Raza", field: "petBreed", value: pet.petBreed },
                            { label: "Fecha Nac", field: "dateBirth", value: pet.dateBirth },
                            { label: "Carácter", field: "petCharacter", value: pet.petCharacter },

                            { label: "Color", field: "petColor", value: pet.petColor },
                            { label: "Género", field: "petGender", value: pet.petGender },
                            { label: "Castrado", field: "sterilized", value: pet.sterilized ? "Sí" : "No" },
                            { label: "Microchip", field: "microChip", value: pet.microChip ? "Sí" : "No" },
                            { label: "Dueño", field: "ownerName", value: pet.ownerName },
                            { label: "Email", field: "ownerEmail", value: pet.ownerEmail },

                            { label: "Teléfono", field: "contactPhone", value: pet.contactPhone },
                            { label: "Dirección", field: "location", value: pet.location },
                            { label: "Veterinario", field: "vetName", value: pet.vetName },
                            { label: "Tel. Vet", field: "vetPhone", value: pet.vetPhone },
                            { label: "Dir. Vet", field: "vetAddress", value: pet.vetAddress },

                            { label: "Collar antipulgas", field: "fleaCollar", value: pet.fleaCollar },
                            { label: "Fecha collar", field: "fleaCollarDate", value: pet.fleaCollarDate},
                            { label: "Intolerancia", field: "intolerance", value: pet.intolerance},

                            { label: "Vacunas", field: "petVaccine", value: pet.petVaccine},
                            { label: "Última vacuna", field: "dateLastVaccine", value: pet.dateLastVaccine},

                        ].map(({ label, field, value }) => (
                            <div className="detail-row" key={field}>
                                <span className="label">{label}:</span>
                                <span className="value">
                                    {editablePetId === pet.petId && editedField === field ? (
                                        <EditMessageModal
                                            show={showModal}
                                            onClose={() => setShowModal(false)}
                                            petId={pet.petId}
                                            field={field}
                                            currentValue={value}
                                            handleSave={handleSave}
                                        />
                                    ) : (
                                        <>
                                            {value}
                                            <i
                                                className="fas fa-pencil-alt"
                                                onClick={() => handleEditClick(pet.petId, field, value)}
                                                style={{ cursor: "pointer", marginLeft: "10px" }}
                                            ></i>
                                        </>
                                    )}
                                </span>
                            </div>
                        ))}
                    </div>
    
                    <div className="pet-actions">
                        <a href={`https://www.pet-connect.shop/pet?petId=${pet.petId}`} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="view-link">
                            <i className="fas fa-search"></i> Ver Perfil
                        </a>
                    </div>
                </div>
            ))}
        </div>
    
        <EditImageModal
            show={showUploadModal}
            onClose={() => setShowUploadModal(false)}
            petId={selectedPetId}
            currentImageUrl={pets.find((pet) => pet.petId === selectedPetId)?.uploadedImageUrl}
            handleUpload={handleImageUpload}
        />
    
        <button onClick={() => navigate("/admin/create")} className="back-button-list-pets">
            Volver
        </button>
    </div>
    
    );
};
export default ListPets;
